module.exports = __webpack_public_path__ + "img/selected5-min.857b958b.png";